/*
|--------------------------------------------------------------------------
| USER ROLES
|--------------------------------------------------------------------------
*/

export const ROLES = {
  ADMIN: "ADMIN",
  SALES: "SALES",
  AGENT: "AGENT",
};

/*
|--------------------------------------------------------------------------
| USER STATUS
|--------------------------------------------------------------------------
*/

export const USER_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  SUSPENDED: "SUSPENDED",
};

/*
|--------------------------------------------------------------------------
| MANAGEABLE ROLES
|--------------------------------------------------------------------------
|
| ADMIN can create/manage:
| - SALES
| - AGENT
|
*/

export const MANAGEABLE_ROLES = [
  ROLES.SALES,
  ROLES.AGENT,
];

/*
|--------------------------------------------------------------------------
| AUTH STORAGE
|--------------------------------------------------------------------------
*/

export const AUTH_STORAGE_KEYS = {
  TOKEN: "harshait_token",
  USER: "harshait_user",
};

/*
|--------------------------------------------------------------------------
| AUTH API ENDPOINTS
|--------------------------------------------------------------------------
*/

export const AUTH_ENDPOINTS = {
  LOGIN: "/auth/login",
  ME: "/auth/me",
  USERS: "/auth/users",
};

/*
|--------------------------------------------------------------------------
| AUTH MESSAGES
|--------------------------------------------------------------------------
*/

export const AUTH_MESSAGES = {
  LOGIN_SUCCESS: "Login successful",

  LOGOUT_SUCCESS: "Logged out successfully",

  SESSION_EXPIRED:
    "Your session has expired. Please login again.",

  UNAUTHORIZED:
    "You are not authorized to perform this action.",

  ACCOUNT_INACTIVE:
    "Your account is not active.",
};